import React, { useState, useEffect } from 'react';
import Layout from '../shared/Layout';

// Importar componentes de Jefatura
import JefaturaAsignaturasMatriculacion from './JefaturaAsignaturasMatriculacion';
import JefaturaHorariosPreadmision from './JefaturaHorariosPreadmision';
import JefaturaDocentesAltas from './JefaturaDocentesAltas';
import JefaturaDocentesDocs from './JefaturaDocentesDocs';
import JefaturaLicenciasDocentes from './JefaturaLicenciasDocentes';
import JefaturaLicenciasEstudiantes from './JefaturaLicenciasEstudiantes';
import JefaturaPrestamos from './JefaturaPrestamos';
import JefaturaReportes from './JefaturaReportes';
import JefaturaEncuestas from './JefaturaEncuestas';
import JefaturaHorarios from './JefaturaHorarios';
import JefaturaCursos from './JefaturaCursos';
import JefaturaEstudiantes from './JefaturaEstudiantes';
import JefaturaDocentesAsignaturas from './JefaturaDocentesAsignaturas';
import JefaturaCursosInscritos from './JefaturaCursosInscritos';
import JefaturaConsultas from './JefaturaConsultasAsignaturas';
import JefaturaConsultasAsignaturas from './JefaturaConsultasAsignaturas';
import JefaturaHistorialAcademico from './JefaturaHistorialAcademico';
import JefaturaConsultasEstudiantes from './JefaturaConsultasEstudiantes';

const DashboardJefatura = ({ onLogout, userName = 'Usuario', menuItems: externalMenuItems, sourceUrl }) => {

    const [menuItems, setMenuItems] = useState([]);
    const [activeMenu, setActiveMenu] = useState(null);

    // Normalizar menús y crear estructura jerárquica
    useEffect(() => {
        if (Array.isArray(externalMenuItems) && externalMenuItems.length > 0) {
            // Filtrar jefatura_root y menús ocultos (Estudiantes y Horarios Preadmisión)
            const hiddenMenuIds = ['68', '59'];
            const filtered = externalMenuItems.filter(m =>
                m.clave !== 'jefatura_root' &&
                m.id !== 'jefatura_root' &&
                !hiddenMenuIds.includes(String(m.id_menu))
            );

            // Construir jerarquía desde id_padre
            const itemMap = {};
            const roots = [];

            // Crear todos los items
            filtered.forEach(item => {
                itemMap[item.id_menu || item.id] = {
                    id: item.id || item.clave,
                    label: item.label || item.etiqueta,
                    id_padre: item.id_padre,
                    id_menu: item.id_menu,
                    orden: item.orden || 0,
                    children: []
                };
            });

            // Asignar hijos a padres
            Object.values(itemMap).forEach(item => {
                if (item.id_padre && itemMap[item.id_padre]) {
                    itemMap[item.id_padre].children.push(item);
                } else if (!item.id_padre || !itemMap[item.id_padre]) {
                    roots.push(item);
                }
            });

            // Ordenar
            const sortByOrden = arr => {
                arr.sort((a, b) => (a.orden || 0) - (b.orden || 0));
                arr.forEach(item => item.children && sortByOrden(item.children));
            };
            sortByOrden(roots);

            // Transformar menú de Asignaturas para agregar submenús manuales
            const finalMenu = roots.map(item => {
                if (item.id === 'jefatura_horarios' || item.label?.toLowerCase().includes('asignatura')) {
                    return {
                        id: 'jefatura_asignaturas',
                        label: 'Registro de Asignaturas',
                        children: [
                            { id: 'jefatura_asignaturas_preadmision', label: 'Admisión', children: [] },
                            { id: 'jefatura_asignaturas_matriculacion', label: 'Licenciatura', children: [] }
                        ]
                    };
                }
                if (item.id === 'jefatura_cursos' || item.label?.toLowerCase().includes('curso')) {
                    return {
                        id: 'jefatura_cursos',
                        label: 'Cursos de Extensión',
                        children: [
                            { id: 'jefatura_cursos_extensión', label: 'Cursos', children: [] },
                            { id: 'jefatura_cursos_inscritos', label: 'Inscritos', children: [] }
                        ]
                    };
                }

                if (item.id === 'jefatura_consultas' || item.label?.toLowerCase().includes('consultas')) {
                    return {
                        id: 'jefatura_consultas',
                        label: 'Consultas',
                        children: [
                            { id: 'jefatura_consultas_asignaturas', label: 'Asignaturas', children: [] },
                            { id: 'jefatura_consultas_historialacadémico', label: 'Historial Académico', children: [] },
                            { id: 'jefatura_consultas_estudiantes', label: 'Estudiantes', children: [] },

                        ]
                    };
                }

                // Inyectar sub-pestaña "Asignaturas" en el menú de Docentes
                if (item.id === 'jefatura_docentes' || item.label?.toLowerCase().includes('docente')) {
                    const existingChildren = item.children || [];
                    const hasAsignaturas = existingChildren.some(c => c.id === 'jefatura_docentes_asignaturas');
                    if (!hasAsignaturas) {
                        return {
                            ...item,
                            children: [
                                ...existingChildren,
                                { id: 'jefatura_docentes_asignaturas', label: 'Asignaturas', children: [] }
                            ]
                        };
                    }
                }
                return item;
            });

            // Eliminar duplicados
            const unique = finalMenu.filter((item, index, self) =>
                index === self.findIndex(t => t.id === item.id)
            );

            setMenuItems(unique);

            // Primer menú clickeable
            const findFirstClickable = items => {
                for (const item of items) {
                    if (!item.children || item.children.length === 0) return item.id;
                    const child = findFirstClickable(item.children);
                    if (child) return child;
                }
                return null;
            };
            setActiveMenu(findFirstClickable(unique) || unique[0]?.id);
        }
    }, [externalMenuItems]);

    // Render de contenido según menú seleccionado
    const renderContent = () => {
        switch (activeMenu) {
            // Asignaturas - Matriculación (horarios regulares)
            case 'jefatura_asignaturas_matriculacion':
                return <JefaturaAsignaturasMatriculacion />;

            case 'jefatura_horarios':
                return <JefaturaHorarios />;

            // Asignaturas - Preadmisión
            case 'jefatura_asignaturas_preadmision':
            case 'jefatura_horarios_preadmision':
                return <JefaturaHorariosPreadmision />;

            case 'jefatura_docentes':
            case 'jefatura_docentes_altas':
                return <JefaturaDocentesAltas />;

            case 'jefatura_docentes_docs':
                return <JefaturaDocentesDocs />;

            case 'jefatura_docentes_asignaturas':
                return <JefaturaDocentesAsignaturas />;

            case 'jefatura_licencias':
            case 'jefatura_licencias_docentes':
                return <JefaturaLicenciasDocentes />;

            case 'jefatura_licencias_estudiantes':
                return <JefaturaLicenciasEstudiantes />;

            case 'jefatura_prestamos':
                return <JefaturaPrestamos />;

            case 'jefatura_reportes':
                return <JefaturaReportes />;

            case 'jefatura_encuestas':
                return <JefaturaEncuestas />;

            case 'jefatura_cursos_extensión':
                return <JefaturaCursos />;

            case 'jefatura_consultas_asignaturas':
                return <JefaturaConsultasAsignaturas />;

            case 'jefatura_cursos_inscritos':
                return <JefaturaCursosInscritos />;

            case 'jefatura_estudiantes':
                return <JefaturaEstudiantes />;

            case 'jefatura_consultas_historialacadémico':
                return <JefaturaHistorialAcademico />;

            case 'jefatura_consultas_estudiantes':
                return <JefaturaConsultasEstudiantes />;

            default:
                return (
                    <div className="p-8">
                        <div className="bg-white rounded-lg shadow-sm p-6 text-gray-600">
                            Sección en desarrollo. (Menu ID: {activeMenu})
                        </div>
                    </div>
                );
        }
    };

    return (
        <Layout
            userRole="Jefatura de Carrera"
            userName={userName}
            onLogout={onLogout}
            menuItems={menuItems}
            activeMenu={activeMenu}
            setActiveMenu={setActiveMenu}
        >
            {renderContent()}
        </Layout>
    );
};

export default DashboardJefatura;

